import { render } from "./date-picker.vue?vue&type=template&id=427c898f&ts=true"
import script from "./date-picker.component.ts?vue&type=script&lang=ts"
export * from "./date-picker.component.ts?vue&type=script&lang=ts"

import exportComponent from "D:\\trainsit project\\LTMS\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__